import { Me } from 'types'
import { getUserId, updateUserId, useMutationHandler, useQueryHandler } from 'utils'

//useMe:
export const useMe = () => useQueryHandler<Me>({
    query: `
        query getMyInfo{
            getMyInfo{

                id
                email
                firstName
                lastName

                image{
                    id
                    path
                }
                
                locale
                loginStrategy
                
            }
        }
    `,
    cacheKey: ['me', getUserId()],
    onSuccess: json => {
        const info = json.data.getMyInfo
        updateUserId(info?.id ?? null)
        return info
    }
})

//update:
type ProfileUpdateResponse = null | boolean | 'locale_is_not_supported'
export const useProfileUpdate = (me: Me) => useMutationHandler<ProfileUpdateResponse>({
    query: `
        mutation updateMe(
            $request: UpdateMeRequest!
        ){
            updateMe(
                request: $request
            ){
                email
            }
        }
    `,
    variables: {
        request: {
            firstName: me.firstName,
            lastName: me.lastName,
            locale: me.locale
        }
    },
    onSuccess: json => json.data.updateMe.email === me.email,
    onError: json => {
        if(json.errors[0].extensions.errors[0].constraints[0].name === 'is_config_locale'){
            return 'locale_is_not_supported'
        }else{
            return null
        }
    }
})

//useSetPassword:
export const useSetPassword = (password: string) => useMutationHandler({
    query: `
        mutation updatePassword (
            $request: UpdatePasswordRequest!
        ) {
            updatePassword(
                request: $request
            )
        }
    `,
    variables: {
        request: {
            currentPassword: null,
            password,
            rePassword: password
        }
    },
    sensitiveQuery: true,
    onSuccess: json => json.data.updatePassword === ''
})

//useInitGoogleSync:
export const useInitGoogleSync = () => useMutationHandler<string>({
    query: `
        mutation initGoogleSync {
            initGoogleSync {
                code
            }
        }
    `,
    onSuccess: json => json.data.initGoogleSync.code
})
